export default __webpack_public_path__ + "static/media/calling.3de3b396.mp3";